interface ILinkedTextCellProps {
  items: string[] | null | undefined,
}

const LinkedTextCell = ({ items }: ILinkedTextCellProps) => {
  if (!items || items.length === 0) {
    return (<>-</>);
  }

  return (<>{ items.join(', ') }</>);
};

export default LinkedTextCell;
